import { http } from "../client";
export var copyPlaylist = function (id) {
    return http.api
        .post("playlists/" + id + "/copy")
        .then(function (response) { return ({ id: response.data.playlist_id }); });
};
